import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ref, onValue, query, limitToLast, get } from "firebase/database";
import { db } from "../../../../assets/firebase/firebaseconfig";
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
import { createSlug } from "../../../../assets/js/slug";

// *** COMPONENT RENDER SAO (Giữ nguyên logic của bạn) ***
const StarRating = ({ rating = 5 }) => {
  const totalStars = 5;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars <= 0.75;
  const stars = [];

  for (let i = 1; i <= fullStars; i++) {
    stars.push(
      <span key={`full-${i}`} className="star full">
        ★
      </span>
    );
  }
  if (hasHalfStar) {
    stars.push(
      <span key="half" className="star half">
        ★
      </span>
    );
  }
  const remainingEmptyStars = totalStars - stars.length;
  for (let i = 1; i <= remainingEmptyStars; i++) {
    stars.push(
      <span key={`empty-${i}`} className="star empty">
        ☆
      </span>
    );
  }
  return <div className="star-rating">{stars}</div>;
};

const ProjectShowcase = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. Lấy dữ liệu từ Firebase
  useEffect(() => {
    // Lấy 4 dự án mới nhất để hiển thị
    const projectsRef = query(ref(db, "projects"), limitToLast(4));

    const unsubscribe = onValue(projectsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const projectList = Object.keys(data)
          .map((key) => ({
            id: key,
            ...data[key],
          }))
          .reverse(); // Đảo ngược để dự án mới nhất lên đầu
        setProjects(projectList);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getRevealClass = (isVisible) =>
    `service-card scroll-reveal-item ${isVisible ? "is-visible" : ""}`;

  if (loading) return <div className="text-center py-5">Đang tải dự án...</div>;

  return (
    <section className="project-showcase">
      <h3 className="project__subtitle">CÁC DỰ ÁN TIÊU BIỂU CỦA HABAKO M&E</h3>

      <div className="project__grid">
        {projects.map((project, index) => {
          return (
            <ProjectItem
              key={project.id}
              project={project}
              index={index}
              getRevealClass={getRevealClass}
            />
          );
        })}
      </div>

      <div className="project__cta-wrapper">
        <Link to="/du-an" className="project__view-all-btn">
          XEM THÊM TẤT CẢ DỰ ÁN
        </Link>
      </div>
    </section>
  );
};

// Component con để sử dụng Hook Reveal đúng quy tắc
const ProjectItem = ({ project, index, getRevealClass }) => {
  const [cardRef, isCardVisible] = useScrollReveal({ threshold: 0.3 });
  console.log("ppp", project);
  return (
    <div
      ref={cardRef}
      className={` project__card ${getRevealClass(isCardVisible)}`}
      style={{ "--reveal-delay": `${index * 0.1}s` }}
    >
      <div className="project__image-wrapper">
        <img
          
          src={project.image}
          alt={project.title}
          className="project__image"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/500x300";
          }}
        />
      </div>

      <h4 className="project__name">{project.title}</h4>

      {}
      <StarRating rating={project.rating || 5} />

      <p className="project__description-showcase">
        {project.summary ||
          "Dự án tiêu biểu được thi công bởi đội ngũ kỹ thuật Habako M&E..."}
      </p>

      <Link to={`/du-an/${project.slug || createSlug(project.name)}`} className="project__detail-btn">
        CHI TIẾT
      </Link>
    </div>
  );
};

export default ProjectShowcase;
